import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=6cd7b1f6&scoped=true&"
import script from "./Poster.vue?vue&type=script&lang=ts&"
export * from "./Poster.vue?vue&type=script&lang=ts&"
import style0 from "./Poster.vue?vue&type=style&index=0&id=6cd7b1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd7b1f6",
  null
  
)

export default component.exports